import { calculateSalary, calculateSalaryIncrease } from '../salaryCalculator.js';

function getCurrency() {
    return document.getElementById('currency').value;
}

function formatCurrency(val, currency) {
    try {
        return new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: currency, 
            maximumFractionDigits: 2 
        }).format(val);
    } catch {
        return `${currency} ${val.toFixed(2)}`;
    }
}

function calculateConversion() {
    const input = {
        amount: parseFloat(document.getElementById('amount').value),
        frequency: document.getElementById('frequency').value,
        hoursPerWeek: parseFloat(document.getElementById('hours').value),
        daysPerWeek: parseFloat(document.getElementById('days').value),
        vacationDays: parseFloat(document.getElementById('vacation').value)
    };

    const result = calculateSalary(input);
    if (!result) return;

    const currency = getCurrency();

    document.getElementById('conversionResults').innerHTML = `
        <table class="results-table">
            <tr><th>Frequency</th><th>Amount</th></tr>
            <tr><td>Annual</td><td>${formatCurrency(result.annual, currency)}</td></tr>
            <tr><td>Monthly</td><td>${formatCurrency(result.monthly, currency)}</td></tr>
            <tr><td>Weekly</td><td>${formatCurrency(result.weekly, currency)}</td></tr>
            <tr><td>Daily</td><td>${formatCurrency(result.daily, currency)}</td></tr>
            <tr><td>Hourly</td><td>${formatCurrency(result.hourly, currency)}</td></tr>
        </table>
        <p style="font-size: 0.75rem; color: #6b7280; margin-top: 1rem;">
            Calculated based on ${result.meta.workDaysPerYear} working days and ${result.meta.workHoursPerYear} working hours per year. Contractual weekly pay assumes 52 weeks.
        </p>
    `;
}

function calculateIncrease() {
    const oldS = parseFloat(document.getElementById('oldSalary').value);
    const newS = parseFloat(document.getElementById('newSalary').value);
    
    const result = calculateSalaryIncrease(oldS, newS);
    if (!result) return;

    const currency = getCurrency();
    const isDecrease = result.isDecrease;

    document.getElementById('increaseResults').innerHTML = `
        <div class="increase-result ${isDecrease ? 'decrease' : ''}">
            <p style="margin: 0; color: #6b7280;">${isDecrease ? 'Salary Decrease' : 'Salary Increase'}</p>
            <h3 class="percentage">${result.percentage.toFixed(2)}%</h3>
            <p style="margin: 0.5rem 0 0; font-weight: 500;">
                ${formatCurrency(result.annualDifference, currency)} / year<br>
                <span style="font-size: 0.875rem; color: #6b7280;">(${formatCurrency(result.monthlyDifference, currency)} / month)</span>
            </p>
        </div>
    `;
}

// Event Listeners
document.getElementById('calculateConversionBtn').addEventListener('click', calculateConversion);
document.getElementById('calculateIncreaseBtn').addEventListener('click', calculateIncrease);
document.getElementById('currency').addEventListener('change', () => {
    calculateConversion();
    calculateIncrease();
});

// Initial load
calculateConversion();
calculateIncrease();
